import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

const DollarCircleIcon = (props: SvgIconProps) => (
  <SvgIcon
    sx={{
      width: 32,
      height: 30,
    }}
    width="32"
    height="30"
    viewBox="0 0 32 30"
    fill={"none"}
  >
    <path
      d="M1.96491 14.4892C1.59316 14.4892 1.34532 14.1794 1.34532 13.8696C1.46924 7.302 6.302 1.66378 12.8076 0.486567C16.4632 -0.194976 20.1807 0.610483 23.2167 2.71707C26.2526 4.82366 28.3592 8.0455 28.9788 11.701C29.0407 12.0108 28.7929 12.3826 28.4831 12.4445C28.1733 12.5065 27.8016 12.2587 27.7396 11.9489C27.12 8.60312 25.2613 5.69108 22.4732 3.77036C19.685 1.84965 16.2773 1.10615 12.9935 1.72574C7.10746 2.77903 2.70841 7.92158 2.58449 13.9316C2.58449 14.2413 2.33666 14.4892 1.96491 14.4892Z"
      fill="#000D8C"
      stroke="#000D8C"
      strokeWidth="0.5"
    />
    <path
      d="M28.4212 12.4446C28.2972 12.4446 28.1733 12.4446 28.1114 12.3826L25.3232 10.7097C25.0134 10.5239 24.9515 10.1521 25.1374 9.84231C25.3232 9.53252 25.695 9.47056 26.0048 9.65644L28.2972 11.0195L29.6603 8.72706C29.8462 8.41727 30.218 8.35531 30.5277 8.54118C30.8375 8.72706 30.8995 9.09881 30.7136 9.4086L29.0407 12.1967C28.9788 12.3207 28.7929 12.4446 28.669 12.5065C28.4831 12.4446 28.4831 12.4446 28.4212 12.4446Z"
      fill="#000D8C"
      stroke="#000D8C"
      strokeWidth="0.5"
    />
    <path
      d="M15.5958 29.4831C12.8076 29.4831 10.0195 28.6157 7.66509 27.0048C4.62912 24.8982 2.52254 21.6764 1.90295 18.0208C1.84099 17.711 2.08883 17.3393 2.39862 17.2773C2.70841 17.2154 3.08016 17.4632 3.14212 17.773C3.76171 21.1187 5.62046 24.0308 8.40859 25.9515C11.1967 27.8722 14.6044 28.6157 17.8882 27.9961C23.7743 26.9428 28.1733 21.8003 28.2972 15.7903C28.2972 15.4186 28.607 15.1707 28.9168 15.1707C29.2886 15.1707 29.5364 15.4805 29.5364 15.7903C29.4125 22.3579 24.5797 27.9961 18.0741 29.1733C17.2686 29.4212 16.4632 29.4831 15.5958 29.4831Z"
      fill="#000D8C"
      stroke="#000D8C"
      strokeWidth="0.5"
    />
    <path
      d="M0.849658 21.3046C0.725741 21.3046 0.601824 21.3046 0.539865 21.2427C0.230073 21.0568 0.168115 20.685 0.35399 20.3753L2.02687 17.5871C2.08883 17.4632 2.2747 17.3393 2.39862 17.2773C2.58449 17.2154 2.70841 17.2773 2.89429 17.3393L5.68242 19.0122C5.99221 19.198 6.05417 19.5698 5.86829 19.8796C5.68242 20.1894 5.31067 20.2513 5.00087 20.0655L2.70841 18.7024L1.34533 20.9948C1.28337 21.2427 1.09749 21.3046 0.849658 21.3046Z"
      fill="#000D8C"
      stroke="#000D8C"
      strokeWidth="0.5"
    />
    <path
      d="M16.0914 13.8696V8.789C17.7024 8.97487 18.6317 10.0282 18.6317 11.5152V11.5771H19.9948V11.5152C19.9948 8.91292 17.8882 7.73571 16.0914 7.54983V6.49654H14.9142V7.54983C12.6837 7.73571 11.1348 9.22271 11.1348 11.1434C11.1348 13.7457 12.9316 14.4272 14.9142 14.9229V20.4991C13.1174 20.2513 12.0022 19.0741 12.0022 17.4632V17.4012H10.6391V17.4632C10.6391 19.8176 12.3739 21.5524 14.9142 21.8003V23.2253H16.0914V21.8003C18.6317 21.6144 20.3046 20.0654 20.3046 17.9588C20.3046 14.9848 17.9502 14.3653 16.0914 13.8696ZM14.9142 13.5598C13.4272 13.0641 12.4978 12.5065 12.4978 11.1434C12.4978 9.90425 13.4272 8.97487 14.9142 8.789V13.5598ZM16.0914 20.5611V15.2327C17.5784 15.6664 18.9415 16.1621 18.9415 18.0208C18.9415 19.4459 17.8263 20.3752 16.0914 20.5611Z"
      fill="#000D8C"
      stroke="#000D8C"
      strokeWidth="0.5"
    />
  </SvgIcon>
);

export default DollarCircleIcon;
